require('./groupPanel')
require('./tabs')
//require('./timeline')
require('./scrollToTop')
//require('./slider')
//require('./auto-slider')
//require('./accodion')
require('./playButton')
require('./accent')
//require('./comparison-table')
//require('./hotspots')
//require('./hotspot-image')
require('./language-switch')
require('./toggle')
require('./3d-configurator')
//require('./video');
//require('./download-list');
//require('./flow-grid');